import { render, staticRenderFns } from "./addDealer.vue?vue&type=template&id=d141540c&scoped=true&"
import script from "./addDealer.vue?vue&type=script&lang=js&"
export * from "./addDealer.vue?vue&type=script&lang=js&"
import style0 from "./addDealer.vue?vue&type=style&index=0&id=d141540c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d141540c",
  null
  
)

export default component.exports